import React from "react";

export const CandleStickSvg: React.FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19 7C19 6.44772 18.5523 6 18 6C17.4477 6 17 6.44772 17 7V11C17 11.5523 17.4477 12 18 12C18.5523 12 19 11.5523 19 11V7ZM11 7.00098C11 6.44869 10.5523 6.00098 10 6.00098C9.44772 6.00098 9 6.44869 9 7.00098V18.001C9 18.5533 9.44772 19.001 10 19.001C10.5523 19.001 11 18.5533 11 18.001V7.00098ZM7 14C7 13.4477 6.55228 13 6 13C5.44772 13 5 13.4477 5 14V18C5 18.5523 5.44772 19 6 19C6.55228 19 7 18.5523 7 18V14ZM13 10C13 9.44772 13.4477 9 14 9C14.5523 9 15 9.44772 15 10V14C15 14.5523 14.5523 15 14 15C13.4477 15 13 14.5523 13 14V10Z"
      ></path>
    </svg>
  );
};
